module.exports = __webpack_public_path__ + "img/634.afcf9125.gif";